import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const VehicleTypeContext = createContext();

export const VehicleTypeProvider = ({ children, initial = 'general' }) => {
  const [vehicleType, setVehicleType] = useState(initial);

  return (
    <VehicleTypeContext.Provider value={{ vehicleType, setVehicleType }}>
      {children}
    </VehicleTypeContext.Provider>
  );
};

VehicleTypeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initial: PropTypes.string,
};

export const useVehicleTypeContext = () => useContext(VehicleTypeContext);
